import React, { useEffect, useRef, useState } from 'react';
import { SelectComponent, TextComponent, TooltipComponent } from '../../../uiComponents';
import { OptionProps, SelectPropsData, TextPropsData } from '../../../../view-models';
import { SelectChangeEvent } from '@mui/material';
import constants from '../../../../constants/constants';

interface StringFormatSelectorProps {
    data: any;
    claimsList: OptionProps[];
    writeback: (data: any) => void;
    inputClaim1FieldName: string;
    inputClaim2FieldName: string;
    formatStringFieldName: string;
}

export const StringFormatSelectorComponent = ({
    data,
    claimsList,
    writeback,
    inputClaim1FieldName,
    inputClaim2FieldName,
    formatStringFieldName
}: StringFormatSelectorProps) => {
    return (
        <>
            <SelectComponent
                changeHandler={(e: SelectChangeEvent<string>) => {
                    writeback({
                        ...data,
                        [inputClaim1FieldName]: e.target.value
                    });
                }}
                data={{
                    value: data[inputClaim1FieldName] ? data[inputClaim1FieldName] : '',
                    label: 'Input Claim 0',
                    style: { margin: 1, width: 350 },
                    options: claimsList.filter((clOption: OptionProps) => clOption.value !== data[inputClaim2FieldName])
                }}
            />
            <SelectComponent
                changeHandler={(e: SelectChangeEvent<string>) => {
                    writeback({
                        ...data,
                        [inputClaim2FieldName]: e.target.value
                    });
                }}
                data={{
                    value: data[inputClaim2FieldName] ? data[inputClaim2FieldName] : '',
                    label: 'Input Claim 1',
                    style: { margin: 1, width: 350 },
                    options: [...claimsList.filter((clOption: OptionProps) => clOption.value !== data[inputClaim1FieldName]), {value: '', label: ''}]
                }}
            />
            <TextComponent
                changeHandler={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
                    writeback({
                        ...data,
                        [formatStringFieldName]: e.target.value
                    })
                }}
                data={{
                    value: data[formatStringFieldName] ? data[formatStringFieldName] : '',
                    label: 'Format String',
                    style: { margin: 1, width: 400 },
                }}
            />
            <TooltipComponent
                title="Format String"
                desc="The format string that will be used to generate the value. '{0}' in the string will be replaced by the first input claim, while '{1}' will be replaced by the second."
            />
        </>
    );
}
